export const AUTO_SUBMIT_DELAY_SECONDS = 3;

export const isPermanentCaptureUploadFailure = (error) => (
  [400, 413, 422].includes(error?.response?.status)
);

export const applyCaptureUploadFailurePolicy = async ({
  error,
  captureId,
  sessionId,
  deleteCapture,
  refreshCaptures,
}) => {
  if (!isPermanentCaptureUploadFailure(error)) return false;
  await deleteCapture(captureId).catch(() => {});
  await refreshCaptures(sessionId).catch(() => {});
  return true;
};

export const beginAutoSubmissionCountdown = ({
  onTick,
  onSubmit,
  delaySeconds = AUTO_SUBMIT_DELAY_SECONDS,
}) => {
  let active = true;
  let remaining = delaySeconds;
  onTick(remaining);

  const timer = setInterval(() => {
    if (!active) return;
    remaining -= 1;
    onTick(remaining);
    if (remaining <= 0) {
      active = false;
      clearInterval(timer);
      onSubmit();
    }
  }, 1000);

  return () => {
    if (!active) return;
    active = false;
    clearInterval(timer);
  };
};
